// Localize presentation only. Field names, submitted values and validators stay server-owned.
export function localizeHookSchema(schema, appId, t, te) {
  return (schema || []).map(field => {
    const prefix = `INTEGRATION_APPS.FIELDS.${appId}.${field.name}`;
    const translate = (suffix, fallback) =>
      te(`${prefix}.${suffix}`) ? t(`${prefix}.${suffix}`) : fallback;
    const localized = { ...field };
    ['label', 'help', 'validationName'].forEach(key => {
      if (field[key]) localized[key] = translate(key, field[key]);
    });
    if (field['validation-messages']) {
      localized['validation-messages'] = Object.fromEntries(
        Object.entries(field['validation-messages']).map(([rule, message]) => [
          rule,
          translate(`messages.${rule}`, message),
        ])
      );
    }
    if (Array.isArray(field.options)) {
      localized.options = field.options.map(option => ({
        ...option,
        label: translate(`options.${option.value}`, option.label),
      }));
    }
    return localized;
  });
}
